import call from "./call";
import {
  EvaluationConfigDefaults,
  EvaluationHistory,
  SingleEvaluationResponse,
} from "../Models/evaluation";

export const getEvaluation = async (
  evaluationId: number,
): Promise<SingleEvaluationResponse> => {
  const { data } = await call.get<SingleEvaluationResponse>(
    `/v1/evaluation/${evaluationId}/`,
    {
      snack: {
        error: "evaluations.fetchDetailsError",
      },
    },
  );
  return data;
};

export const deleteEvaluation = async (evaluationId: string): Promise<void> => {
  await call.delete(`/v1/evaluation/${evaluationId}/`, {
    snack: {
      success: "evaluations.deleteSuccess",
      error: "evaluations.deleteError",
    },
  });
};

export const getEvaluationHistory = async (
  companyId: string,
  page: number,
  rowsPerPage: number,
  search: string = "",
  sort_order: string = "created_at",
  sort: "asc" | "desc" = "asc",
): Promise<EvaluationHistory> => {
  const { data } = await call.get<EvaluationHistory>(
    `/v1/evaluation/history/${companyId}/`,
    {
      params: {
        page: page + 1,
        page_size: rowsPerPage,
        search,
        sort_order,
        sort_direction: sort,
      },
    },
  );

  return data;
};

export const downloadEvaluation = async (
  user_evaluation_request_id: string,
) => {
  const response = await call.get(
    `/v1/evaluation/history/${user_evaluation_request_id}/download`,
    {
      responseType: "blob",
      snack: {
        error: "evaluations.downloadHistoryError",
      },
    },
  );

  return response;
};

export const pauseEvaluation = async (evaluationId: string) => {
  const response = await call.post(`/v1/evaluation/pause/${evaluationId}/`, {
    snack: {
      success: "evaluations.pauseSuccess",
      error: "evaluations.pauseFailure",
    },
  });

  return response;
};

export const resumeEvaluation = async (evaluationId: string) => {
  const response = await call.post(`/v1/evaluation/resume/${evaluationId}/`, {
    snack: {
      success: "evaluations.resumeSuccess",
      error: "evaluations.resumeFailure",
    },
  });

  return response;
};

export const downloadEvaluationDocument = async (evaluationId: number) => {
  const response = await call.get(`/v1/qa_insights/${evaluationId}/`, {
    responseType: "blob",
    snack: {
      error: "evaluations.failedToDownloadDocument",
    },
  });

  return response;
};

export const getConfigDefaults =
  async (): Promise<EvaluationConfigDefaults> => {
    const { data } = await call.get<EvaluationConfigDefaults>(
      `/v1/evaluation/config-defaults/`,
    );

    return data;
  };
